import { Button, ButtonProps, Flex, Stack } from '@chakra-ui/react'
import React from 'react'

import { useTranslations } from '~shared-components/hooks/useTranslations'

import { IconByName, IconNamesBrand } from '../../icons/brand/'
import { IconClose } from '../../icons/brand/IconClose'
import { TranslationKey } from '../../translations/default'
export interface GenericModalFooterProps {
  actionButtonId?: string
  actionIcon?: IconNamesBrand
  actionTextLabel: TranslationKey
  actionVariant?: ButtonProps['variant']
  cancelIcon?: IconNamesBrand
  cancelTextLabel?: TranslationKey
  children?: React.ReactNode
  isActionDisabled?: boolean
  isLoadingAction?: boolean
  isReactionRequired?: boolean
  onAction: VoidFunction
  onCancel?: VoidFunction
  onReaction?: VoidFunction
  reactionButtonId?: string
  reactionIcon?: IconNamesBrand
  reactionTextLabel?: TranslationKey
  reactionVariant?: ButtonProps['variant']
}

export const GenericModalFooter = ({
  actionButtonId = 'modal-action-btn',
  actionIcon,
  actionTextLabel,
  actionVariant = 'action',
  cancelIcon,
  cancelTextLabel,
  children,
  isActionDisabled,
  isLoadingAction,
  isReactionRequired = false,
  onAction,
  onCancel,
  onReaction,
  reactionButtonId = 'modal-reaction-btn',
  reactionIcon,
  reactionTextLabel,
  reactionVariant = 'solid',
}: GenericModalFooterProps) => {
  const t = useTranslations()
  return (
    <Stack
      alignItems="flex-end"
      direction={['column', 'row']}
      gap={5}
      justifyContent="flex-start"
      spacing={5}
      w="100%"
    >
      <Button
        data-analyticsid={actionButtonId}
        data-testid={actionButtonId}
        disabled={isActionDisabled}
        id={actionButtonId}
        isLoading={isLoadingAction}
        leftIcon={actionIcon && <IconByName boxSize="20px" name={actionIcon} />}
        onClick={onAction}
        variant={actionVariant}
        width={['100%', 'auto']}
      >
        {t(actionTextLabel)}
      </Button>

      {isReactionRequired ? (
        <Button
          data-analyticsid={reactionButtonId}
          data-testid={reactionButtonId}
          disabled={isActionDisabled}
          id={reactionButtonId}
          isLoading={isLoadingAction}
          leftIcon={
            reactionIcon && <IconByName boxSize="20px" name={reactionIcon} />
          }
          onClick={onReaction}
          variant={reactionVariant}
          width={['100%', 'auto']}
        >
          {reactionTextLabel && t(reactionTextLabel)}
        </Button>
      ) : onCancel ? (
        <Button
          data-analyticsid="modal-cancel-btn"
          data-testid="modal-cancel-btn"
          id="modal-cancel-btn"
          leftIcon={
            cancelIcon ? (
              <IconByName boxSize="20px" name={cancelIcon} />
            ) : (
              <IconClose boxSize="20px" />
            )
          }
          onClick={onCancel}
          variant="outline"
          width={['100%', 'auto']}
        >
          {cancelTextLabel ? t(cancelTextLabel) : t('label.cancel')}
        </Button>
      ) : null}

      {children && (
        <Flex
          flex="1 1"
          h="40px"
          justifyContent={['inherit', 'flex-end']}
          mb={['20px !important', '0px !important']}
          order={[-1, 'unset']}
          w="100%"
        >
          {children}
        </Flex>
      )}
    </Stack>
  )
}
